import 'zone.js';
import {bootstrapApplication} from '@angular/platform-browser';
import {provideZoneChangeDetection } from '@angular/core';
import {GusoHeaderNonConnecteComponent, provideGusoLibraryConfiguration} from 'guso-libangular';
import {gusoLibConfig} from '../config/environment';
import { provideHttpClient } from '@angular/common/http';

const selector = 'guso-header-non-connecte';
if (document.querySelector(selector)) {
    bootstrapApplication(GusoHeaderNonConnecteComponent, {providers: [provideZoneChangeDetection(), provideGusoLibraryConfiguration(gusoLibConfig), provideHttpClient()]}).catch(err => console.error('Erreur bootstrap Angular:', err));
} else {
    console.debug(`Balise <${selector}> absente : composant non initialisé.`);
}
